<template>
  <v-app>
      <head>
          <title v-if="user && user.display_name">
              {{user.display_name}} - Foraje
          </title>
          <title v-else>
              User's Profile Page
          </title>
          <meta name="description" :content="user.description">
      </head>
      <v-container v-if="isuserdataloading">
          <v-row  >
              <v-col cols="12" class="text-center">
                <v-progress-circular
                  :size="100"
                  :width="7"
                  color="primary"
                  indeterminate
                />
              </v-col>
          </v-row>
      </v-container>
    <v-container v-else>
      <v-card>
      <v-row>
      <v-col cols="12" sm="4" lg="3" class="py-0">
        <v-img
          :src="user.profile_image.image.medium_square_crop"
          :lazy-src="user.profile_image.image.small_square_crop"
          class="elevation-1 ProfilePicture"
          v-if="user.profile_image && user.profile_image.image"
        >
        </v-img>
        <v-img v-else src="https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg" class="ProfilePicture elevation-1">
        </v-img>
      </v-col>
  <v-col cols="12" sm="8" lg="9" class="pa-6 pa-sm-2">
    <v-row>
      <v-col cols="auto" >
        <h1> <span v-if="user && user.display_name">{{user.display_name}} </span>
          <span v-else>{{user.name}}</span></h1>
      </v-col>
      <v-col cols="12" sm="6" style="overflow: visible" v-if="!UsersOwnProfile">
      <v-btn v-if="!following" rounded :loading="follow_loading" @click="FollowUser" color="primary">
        <v-icon>
          mdi-plus
        </v-icon>
        Follow
      </v-btn>
      <v-btn v-if="following" rounded :loading="follow_loading" @click="UnfollowUser" color="primary" >
        <v-icon>
          mdi-check
        </v-icon>
        Following
      </v-btn>
      <!--<v-btn fab color="primary" small class="ml-3">
        <v-icon>mdi-message-text</v-icon>
      </v-btn>-->
    </v-col>
      <v-col cols="12" sm="6" style="overflow: visible" v-if="UsersOwnProfile">
        <v-btn rounded  :to="'/forms/profiles/edit/'" color="primary">
          <v-icon>
            mdi-pencil
          </v-icon>
          Edit Your Profile
        </v-btn>
        <v-btn v-if="following" rounded :loading="follow_loading" @click="UnfollowUser" color="primary" >
          <v-icon>
            mdi-check
          </v-icon>
          Following
        </v-btn>
      </v-col>
      <v-col cols="12">
            <span style="display: inline-block">Following  {{user.following_count}} </span>
            <span style="display: inline-block;" class="px-sm-5" >Followers  {{user.follower_count}}</span>
            <span style="display: inline-block"><v-icon>mdi-map-marker</v-icon>{{user.location}}</span>
      </v-col>
      <v-col cols="12" v-if="user.description && user.description.length<255" class="pr-5">
        <p>{{user.description}}</p>

      </v-col>
      <v-col cols="12" v-else>
        <p>{{user.description}}</p>
      </v-col>
    </v-row>

  </v-col>
      </v-row>
      </v-card>
    </v-container>


  <v-divider/>
    <v-tabs light fixed icons-and-text centered slider-color="yellow" v-if="!isuserdataloading">
      <v-tab key="shops">
        My Shop(s)
        <v-icon>mdi-store</v-icon>
      </v-tab>
      <v-tab key="products">
            What I'm Selling
            <v-icon>mdi-package-variant-closed</v-icon>
        </v-tab>
      <v-tab-item key='shops'>
        <v-container >
          <v-row>
            <v-col cols="12"><v-card>
              <v-card-text>
              <div v-for="shop in shops" :key="shop.id">
                <router-link :to="'/shops/' + shop.slug">
                  <h3>{{shop.name}}</h3>
                </router-link>
              </div>
              </v-card-text>
            </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

        <v-tab-item key='products'>
            <v-container >
              <v-row>
                <v-col cols="12"><v-card>
                  <v-card-text>
                    <div v-for="product in products" :key="product.id">

                        <h3>{{product.name}} -- ${{product.price.slice(0,-2)}} per {{product.price_units}} </h3>
                    </div>
                  </v-card-text>
                </v-card>
                </v-col>
              </v-row>
            </v-container>
        </v-tab-item>


    </v-tabs>

  </v-app>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Profile',
  data: () => ({

    user: [],
    errors: [],
    dialog: false,
    products: [],
    shops: [],
    isuserdataloading: false,
    following: false,
    follow_loading: false,
    following_relationship_exists: false,


  }),
  methods: {
    GetUserData() {
      this.isuserdataloading = true;
      const userSlug = this.$route.params.slug;
      axios.get(`users/${userSlug}`)
        .then((response) => {
          this.user = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
      /*axios.get(`filtered/baseproduct/by/producer/${userSlug}/`)
        .then((response) => {
          this.crops = response.data.results;
        })
        .catch((e) => {
          this.errors.push(e);
        });*/
      axios.get(`filtered/basics/products/by/vendor/${userSlug}/`)
        .then((response) => {
          this.products = response.data;
        })
      axios.get(`filtered/products/shops/by/owner/${userSlug}/`)
        .then((response) => {
          this.shops = response.data;
          this.isuserdataloading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    // maybe also check the reverse, like if they're following the current user, just add a little box letting the user know or something, kinda like twitter does.
    CheckIfFollowingUser() {
      this.follow_loading = true;
      const userSlug = this.$route.params.slug;
      const authheader = `Token ${this.$store.getters.token}`;
      axios.get(`follow/user/check/${userSlug}`, {
        headers: {
          Authorization: authheader,
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.is_active === true) {
            this.following_relationship_exists = true;
            this.following = true;
          } else if (response.data.is_active === false) {
            this.following_relationship_exists = true;
            this.following = false;
          } else {
            this.following_relationship_exists = false;
            this.following = false;
          }
        })
        .then(() => {
          this.follow_loading = false;
        })
        .catch(() => {
          this.follow_loading = false;
          this.following_relationship_exists = false;
          this.following = false;
        });
    },
    FollowUser() {
      const userSlug = this.$route.params.slug;
      const authheader = `Token ${this.$store.getters.token}`;
      this.follow_loading = true;
      if (this.following_relationship_exists === false) {
        return axios.post(`follow/user/create/${userSlug}`, {}, {
          headers: {
            Authorization: authheader,
          },
        })
          .then(() => {
            this.following = true;
            this.user.follower_count += 1;
            this.follow_loading = false;
            this.following_relationship_exists = true;
          })
          .catch(() => {
            this.follow_loading = false;
          });
      } return axios.patch(`follow/user/update/${userSlug}`, { is_active: true }, {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          this.following = true;
          this.user.follower_count += 1;
          this.follow_loading = false;
          this.following_relationship_exists = true;
        });
    },
    UnfollowUser() {
      const userSlug = this.$route.params.slug;
      const authheader = `Token ${this.$store.getters.token}`;
      this.follow_loading = true;
      axios.patch(`follow/user/update/${userSlug}`, { is_active: false }, {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          this.following = false;
          this.user.follower_count -= 1;
          this.follow_loading = false;
          this.following_relationship_exists = true;
        })
        .catch(() => {
          this.follow_loading = false;
        });
    },
  },
  // Fetches variety info when the component is created.
  created() {
    this.GetUserData();
  },
  mounted() {
    this.CheckIfFollowingUser();
  },
  computed: {
    userIsAuthenticated() {
      return this.$store.state.token !== null && this.$store.getters.user !== undefined;
    },
    currentUser() {
      return this.$store.getters.user;
    },
    UsersOwnProfile() {
      return this.$store.getters['user/user_slug'] === this.$route.params.slug;
    },
  },
  watch: {
    '$route.params.slug': function (slug) {
      this.GetUserData();
      this.CheckIfFollowingUser();
    },
  }
};
</script>

<style scoped>


  .FetchedThumbail{
       border-radius: 50%;
   }
  .ProfilePicture{
    border-radius: 50%;
  }
  .ProfilePictureBackground{

  }
  .ProfilePage{
    background: linear-gradient(#2d796b, #468a7e 10%, #8dbbb3 38%, #add1cb 48%, #eaf1f0 62%)
    repeat scroll;
  }


</style>
